import { ApplicationStore } from '../states'

export const updateUserIdSf: (state: ApplicationStore, payload: string) => ApplicationStore = (state, payload) => {
  return {
    ...state,
    userIdSf: payload,
  }
}

export const removeUserIdSf: (state: ApplicationStore) => ApplicationStore = (state) => {
  const newState: ApplicationStore = JSON.parse(JSON.stringify(state))

  delete newState.userIdSf
  return {
    ...newState,
  }
}
